import { render } from "./DossierNavbar.vue?vue&type=template&id=6ffc8d1c"
import script from "./DossierNavbar.vue?vue&type=script&lang=js"
export * from "./DossierNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__